// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-Bar-bar-module__root","title":"applications-components-ProductsApp-components-Bar-bar-module__title","price":"applications-components-ProductsApp-components-Bar-bar-module__price","button":"applications-components-ProductsApp-components-Bar-bar-module__button"};
    if(module.hot) {
      // 1791528099237
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  